import React from "react";
import "./customerTable.css";

const CustomerTable = ({ title }) => {
  // ** headings
  // ID
  // User Name
  // Email
  // Date
  // Query
  // Status

  const tableData = {
    headings: ["ID", "User Name", "Email", "Date", "Query", "Status"],
    data: [
      {
        id: "#1235666",
        userName: "Iftikhar Yousaf Khan",
        email: "iftikharyousafkhan123@gmail.com",
        date: "29/10/2023, 12:30 AM",
        query: "What is the price of this prem...",
        status: "Resolved",
      },
      {
        id: "#1235666",
        userName: "Iftikhar Yousaf Khan",
        email: "iftikharyousafkhan123@gmail.com",
        date: "29/10/2023, 12:30 AM",
        query: "What is the price of this prem...",
        status: "Unresolved",
      },
    ],
  };

  for (let i = 0; i < 4; i++) {
    tableData.data.push(tableData.data[0]);
  }

  return (
    <div className="pvxCustomerTable">
      <div className="title">
        <span>{title}</span>
        <div className="right">
          <div className="search-box">
            <img
              className="search-icon"
              src="../images/assets/search.png"
              alt="search icon"
            />
            <input
              className="input"
              type="text"
              placeholder="Search by User Name, Date"
            />
          </div>
          <img
            src="./images/PvxDashboard/Icons/Dots.svg"
            className="dots"
            alt="Dots"
          />
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            {tableData.headings.map((heading, index) => (
              <th key={index}>{heading}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.data.map((row, index) => (
            <tr key={index}>
              <td>{row.id}</td>
              <td>{row.userName}</td>
              <td>{row.email}</td>
              <td>{row.date}</td>
              <td>{row.query}</td>
              <td
                style={
                  row.status === "Resolved"
                    ? { color: "#1E9600" }
                    : { color: "#DC3545" }
                }
              >
                {row.status}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerTable;
